<app-breadcrumb
  [title]="'Capacitaciones'"
  [items]="['Capacitaciones']"
  [active_item]="'Listado'"
>
</app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div
      class="card-header d-flex align-items-center justify-content-between bg-primary text-white"
    >
      <div class="d-flex align-items-center">
        <i class="icofont icofont-book-alt me-2"></i>
        <h5 class="mb-0">
          <strong>LISTADO DE CAPACITACIONES</strong>
        </h5>
      </div>
    </div>

    <div class="card-body custom-datatable noscroll">
      <!-- FILTROS -->
      <div class="row mb-3">
        <div class="col-sm-12 col-md-3">
          <select
            class="form-select"
            [(ngModel)]="stateFilter"
            (change)="page = 1; filterData()"
          >
            <option value="all">Todos</option>
            <option value="active">Activos</option>
            <option value="inactive">Inactivos</option>
          </select>
        </div>

        <div class="col-sm-12 col-md-3 ms-auto">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar..."
              [(ngModel)]="searchText"
              (input)="filterData()"
            />

            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>

      <!-- TABLA -->
      <div
        class="custom-datatable table-responsive mt-4"
        *ngIf="!loading; else skeleton"
      >
        <table class="table table-hover table-bordered" id="tblCapacitaciones">
          <thead class="bg-primary">
            <tr>
              <th
                class="text-center"
                style="cursor: pointer"
                (click)="sortData('id')"
              >
                <strong>ID</strong>

                <i
                  class="fa"
                  [ngClass]="{
                    'fa-sort-up':
                      sortColumn === 'id' && sortDirection === 'asc',

                    'fa-sort-down':
                      sortColumn === 'id' && sortDirection === 'desc',

                    'fa-sort': sortColumn !== 'id',
                  }"
                ></i>
              </th>

              <th
                class="text-center"
                style="cursor: pointer"
                (click)="sortData('nombre')"
              >
                <strong>NOMBRE</strong>

                <i
                  class="fa"
                  [ngClass]="{
                    'fa-sort-up':
                      sortColumn === 'nombre' && sortDirection === 'asc',

                    'fa-sort-down':
                      sortColumn === 'nombre' && sortDirection === 'desc',

                    'fa-sort': sortColumn !== 'nombre',
                  }"
                ></i>
              </th>

              <th class="text-center">
                <strong>TEMA</strong>
              </th>


              <th
                class="text-center"
                style="cursor: pointer"
                (click)="sortData('estado')"
              >
                <strong>ESTADO</strong>

                <i
                  class="fa"
                  [ngClass]="{
                    'fa-sort-up':
                      sortColumn === 'estado' && sortDirection === 'asc',

                    'fa-sort-down':
                      sortColumn === 'estado' && sortDirection === 'desc',

                    'fa-sort': sortColumn !== 'estado',
                  }"
                ></i>
              </th>

              <th class="text-center">
                <strong>ACCIONES</strong>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="
                let capacitacion of filteredTableItems
                  | paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: page,
                      }
              "
            >
              <td class="text-center">
                {{ capacitacion.id }}
              </td>

              <td class="text-uppercase">
                {{ capacitacion.nombre }}
              </td>

              <td class="text-uppercase">
                {{ capacitacion.tema || "-" }}
              </td>

              <td class="text-center">
                <span
                  class="badge"
                  [ngClass]="
                    esActivo(capacitacion) ? 'bg-success' : 'bg-secondary'
                  "
                >
                  {{ esActivo(capacitacion) ? "Activo" : "Inactivo" }}
                </span>
              </td>

              <td class="text-center">
                <div class="action">
                  <ul class="list-inline m-0">
                    <li
                      class="edit list-inline-item"
                      *ngIf="esActivo(capacitacion)"
                      (click)="
                        abrirModalEditar(capacitacion, editCapacitacionModal)
                      "
                    >
                      <a href="javascript:void(0)">
                        <i class="icon-pencil-alt" ngbTooltip="Editar"></i>
                      </a>
                    </li>

                    <li
                      class="delete list-inline-item"
                      *ngIf="esActivo(capacitacion)"
                      (click)="inactivarCapacitacion(capacitacion.id)"
                    >
                      <a href="javascript:void(0)">
                        <i class="icon-trash" ngbTooltip="Inactivar"></i>
                      </a>
                    </li>

                    <li
                      class="edit list-inline-item"
                      *ngIf="!esActivo(capacitacion)"
                      (click)="activarCapacitacion(capacitacion.id)"
                    >
                      <a href="javascript:void(0)">
                        <i class="icon-check-box" ngbTooltip="Activar"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- PAGINACIÓN -->
        <div class="d-flex justify-content-between align-items-center mt-4">
          <div class="d-flex align-items-center">
            <label for="pageSize" class="me-2"> Mostrar: </label>

            <select
              id="pageSize"
              class="form-select w-auto"
              [(ngModel)]="pageSize"
              (change)="page = 1"
            >
              <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">
                {{ size }}
              </option>
            </select>

            <span class="ms-2"> registros por página </span>
          </div>

          <div class="text-center flex-grow-1">
            Total Registros:

            <a class="badge badge-primary">
              <b>
                {{ filteredTableItems?.length }}
              </b>
            </a>
          </div>

          <div class="text-end paginador-personalizado">
            <pagination-controls
              (pageChange)="page = $event"
              [maxSize]="5"
              [directionLinks]="true"
              [autoHide]="true"
              previousLabel="Anterior"
              nextLabel="Siguiente"
            >
            </pagination-controls>
          </div>
        </div>

        <!-- BOTONES -->
        <div class="mt-4">
          <div class="btn-showcase text-center">
            <button
              class="btn btn-outline-success-2x"
              type="button"
              (click)="
                exportarExcel('tblCapacitaciones', 'Listado_capacitaciones')
              "
            >
              <i class="icofont icofont-file-excel"></i>
              EXCEL
            </button>

            <button
              class="btn btn-outline-danger-2x"
              type="button"
              (click)="
                exportToPDF(
                  'tblCapacitaciones',
                  'Listado_capacitaciones',
                  'Listado de Capacitaciones'
                )
              "
            >
              <i class="icofont icofont-file-pdf"></i>
              PDF
            </button>

            <button
              class="btn btn-outline-primary-2x"
              type="button"
              (click)="abrirModalNuevo(createCapacitacionModal)"
            >
              <i class="fa fa-plus"></i>
              CREAR
            </button>
          </div>
        </div>

      <!-- SKELETON -->
      <ng-template #skeleton>
        <div class="skeleton-table my-3">
          <table class="table table-hover table-bordered">
            <thead>
              <tr>
                <th *ngFor="let col of [1, 2, 3, 4, 5, 6, 7]">
                  <div class="skeleton skeleton-th"></div>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let row of [].constructor(5)">
                <td *ngFor="let col of [1, 2, 3, 4, 5, 6, 7]">
                  <div class="skeleton skeleton-td"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>

      <!-- MODAL EDITAR -->
      <ng-template #editCapacitacionModal let-modal>
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title mb-0">
            <strong> EDITAR CAPACITACIÓN </strong>
          </h5>

          <button
            type="button"
            class="btn-close btn-close-white"
            aria-label="Close"
            (click)="modal.dismiss()"
          ></button>
        </div>

        <div class="modal-body">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label text-dark">
                <strong>Nombre:</strong>
                <a class="text-danger"> *</a>
              </label>

              <input
                type="text"
                class="form-control text-uppercase"
                [(ngModel)]="editCapacitacionForm.nombre"
              />
            </div>

            <div class="col-md-6">
              <label class="form-label text-dark">
                <strong>Tema:</strong>
                <a class="text-danger"> *</a>
              </label>

              <input
                type="text"
                class="form-control text-uppercase"
                [(ngModel)]="editCapacitacionForm.tema"
              />
            </div>

            <div class="col-md-12">
              <label class="form-label text-dark">
                <strong>Descripción:</strong>
                <a class="text-danger"> *</a>
              </label>

              <textarea
                rows="4"
                class="form-control"
                [(ngModel)]="editCapacitacionForm.descripcion"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="modal.dismiss()"
          >
            Cancelar
          </button>

          <button
            type="button"
            class="btn btn-primary"
            [disabled]="loading"
            (click)="guardarEdicion()"
          >
            <span *ngIf="!loading"> Actualizar </span>

            <span *ngIf="loading"> Guardando... </span>
          </button>
        </div>
      </ng-template>

      <!-- MODAL CREAR -->
      <ng-template #createCapacitacionModal let-modal>
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title mb-0">
            <strong> NUEVA CAPACITACIÓN </strong>
          </h5>

          <button
            type="button"
            class="btn-close btn-close-white"
            aria-label="Close"
            (click)="modal.dismiss()"
          ></button>
        </div>

        <div class="modal-body">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label text-dark">
                <strong>Nombre:</strong>
                <a class="text-danger"> *</a>
              </label>

              <input
                type="text"
                class="form-control text-uppercase"
                placeholder="Ej. Trabajo en alturas"
                [(ngModel)]="newCapacitacionForm.nombre"
              />
            </div>

            <div class="col-md-6">
              <label class="form-label text-dark">
                <strong>Tema:</strong>
                <a class="text-danger"> *</a>
              </label>

              <input
                type="text"
                class="form-control text-uppercase"
                placeholder="Ej. Seguridad Industrial"
                [(ngModel)]="newCapacitacionForm.tema"
              />
            </div>

             <div class="col-md-12">
              <label class="form-label text-dark">
                <strong>Descripción:</strong>
                <a class="text-danger">*</a>
              </label>

              <textarea
                rows="4"
                class="form-control"
                [(ngModel)]="newCapacitacionForm.descripcion"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="modal.dismiss()"
          >
            Cancelar
          </button>

          <button
            type="button"
            class="btn btn-primary"
            [disabled]="loading"
            (click)="guardarNuevaCapacitacion()"
          >
            <span *ngIf="!loading"> Guardar </span>

            <span *ngIf="loading"> Guardando... </span>
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
